import React, { Component } from 'react';

class IconUserAccount extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 56 56"
                style={{
                    width: "80%",
                    height: "80%"
                }}
            >
                <path
                    fill={this.props.isActive ? "#fff" : "#1D53A5"}
                    d="M30.8 15.4a9.8 9.8 0 10-19.6 0 9.8 9.8 0 0019.6 0zM40.6 25.2a6.995 6.995 0 007-7 7 7 0 10-7 7zM30.739 40.256l13.524-13.524a5.237 5.237 0 017.403 7.409L38.142 47.662a6.151 6.151 0 01-2.856 1.619l-4.194 1.047a2.492 2.492 0 01-3.019-3.019l1.047-4.194a6.129 6.129 0 011.619-2.856v-.003zM30.8 28a5.6 5.6 0 015.054 3.18l-7.098 7.096a8.96 8.96 0 00-2.355 4.158l-1.05 4.194c-.056.23-.098.457-.123.68-1.313.191-2.727.292-4.23.292-9.552 0-15.398-4.049-15.398-9.8v-4.2a5.6 5.6 0 015.6-5.6h19.6z"
                ></path>
            </svg>
        );
    }
}

export default IconUserAccount;